import { render, staticRenderFns } from "./catalog.vue?vue&type=template&id=42bc0634&"
import script from "./catalog.vue?vue&type=script&lang=js&"
export * from "./catalog.vue?vue&type=script&lang=js&"
import style0 from "./catalog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42bc0634')) {
      api.createRecord('42bc0634', component.options)
    } else {
      api.reload('42bc0634', component.options)
    }
    module.hot.accept("./catalog.vue?vue&type=template&id=42bc0634&", function () {
      api.rerender('42bc0634', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/catalog.vue"
export default component.exports